import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import CTAButton from '../../components/CTAButton/CTAButton';
import AppDownloadButton from '../../components/AppDownloadButton/AppDownloadButton';
import TmdbAttribution from '../../components/TmdbAttribution/TmdbAttribution';
import styles from './About.module.css';

function About() {
    const navigate = useNavigate();
    return (
        <main className={styles.page}>
            <Helmet>
                <title>About Aluvo — Discover, Rank and Prove What You’ve Watched</title>
                <meta
                    name="description"
                    content="Aluvo is a movie and TV fan platform where you discover what to watch, share your favorites, and prove what you remember through quizzes and collectible coins."
                />
            </Helmet>
            <div className={`container ${styles.inner}`}>
                <h1 className={styles.title}>About <span className={styles.gold}>Aluvo</span></h1>
                <p className={styles.lead}>
                    Aluvo is a movie and TV fan platform where you discover what to watch, share your favorites, and prove
                    what you remember through quizzes and collectible coins.
                </p>

                <section className={styles.section}>
                    <h2>Why we built it</h2>
                    <p>
                        Everyone has a movie they could recite line by line, and a list of favorites they’ll defend to anyone.
                        Aluvo gives that taste and that memory somewhere to live: a place to find your next watch, put your
                        favorites in order, and earn something for what you actually remember.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2>What you can do</h2>
                    <ul className={styles.list}>
                        <li>🍿 <strong>Discover</strong> — browse Aluvo Picks, hand-picked lists like starter packs, and save titles to your watchlist.</li>
                        <li>🏆 <strong>Rank</strong> — make a Top 5 or Top 10 of movies, TV or both, and share it as an image or a link.</li>
                        <li>🧠 <strong>Prove</strong> — answer 8 questions about a movie or TV season to verify you watched it.</li>
                        <li>🪙 <strong>Collect</strong> — earn Bronze, Silver, Gold and Legendary coins, and complete collections for their reward coins.</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2>The Team</h2>
                    <p>
                        Aluvo is built by a small team of film enthusiasts and product builders who got tired of
                        saying "I watched that" with nothing to show for it.
                    </p>
                </section>

                <section className={styles.section} id="credits" aria-labelledby="credits-title">
                    <h2 id="credits-title">Credits</h2>
                    <p>Movie and TV information and posters come from The Movie Database (TMDB).</p>
                    <TmdbAttribution variant="full" />
                </section>

                <div className={styles.cta}>
                    <CTAButton variant="gold" size="lg" onClick={() => navigate('/register')}>
                        Get Started
                    </CTAButton>
                    <AppDownloadButton source="about" />
                </div>
            </div>
        </main>
    );
}

export default About;
